import { windowHelper } from '@tencent/ppd-base-libs';

// 直接replace到活动页面
export function redirectToUrl(actUrl: string) {
  windowHelper.replace(actUrl, 100);
}

/**
 * 跳转到小程序
 */
export function redirectToWxApp(urlSchema: string) {
  windowHelper.redirect(urlSchema, 100);
}
